const account = {
  getAllAccounts: async function() {
    var query = `{
        accounts {
          Account_Id
          Number_Of_Users
          Billing_Name
          Billing_Address_Line_1
          Billing_Address_Line_2
          Billing_City
          Billing_State
          Billing_Zip
          Account_Group {
            Name
          }
        }
      }`;
    return await this.$store.getters.fetcher({ query }).then(r => {
      return r.data.accounts;
    });
  },

  getAccountPermissions: async function(accountId) {
    return await this.$store.getters
      .fetcher({
        query:
          `{
        account(id: ` +
          accountId +
          `) {
          Account_Id
          Organizations {
            Organization_Id
            Name
            Parent_Organization_Id
            Organization_Type_Id
            Users {
              User_Id
              First_Name
              Last_Name
              Permissions{
                UserPermission_Id
                Organization {
                  Organization_Id
                  Name
                }
                Permission {
                  Permission_Id
                  Title
                }
              }
            }
          }
        }
      }`
      })
      .then(r => {
        return r.data.account;
      });
  },

  getAccountOrganizations: async function(accountId) {
    return await this.$store.getters
      .fetcher({
        query:
          `{
        account(id: ` +
          accountId +
          `) {
          Account_Id
          Organizations {
            Organization_Id
            Name
            Parent_Organization_Id
            Organization_Type_Id
          }
        }
      }`
      })
      .then(r => {
        return r.data.account;
      });
  },

  getAccount: async function(accountId) {
    return await this.$store.getters
      .fetcher({
        query:
          `{
        account(id: ` +
          accountId +
          `) {
          Account_Id
          Number_Of_Users
          Billing_Name
          Billing_Address_Line_1
          Billing_Address_Line_2
          Billing_City
          Billing_State
          Billing_Zip
          Billing_Phone
          Account_Group {
            AccountGroup_Id
            Name
          }
          Account_Type{
            Account_Type_Id
            Title
          }
          Payment_Method{
            Payment_Method_Id
            Title
            Cost_Per_User
          }
          Organizations {
            Organization_Id
            Name
            Parent_Organization_Id
            Organization_Type_Id
            Users {
              User_Id
              Account_Id
              First_Name
              Last_Name
              Email
              Phone
              Organization_Id
              Permissions{
                UserPermission_Id
                Organization {
                  Organization_Id
                  Name
                }
                Permission {
                  Permission_Id
                  Title
                }
              }
            }
          }
          District_Contacts{
            District_Contact_Id
            Name
            Email
            Phone
            Address_Line_1
            Address_Line_2
            City
            State
            Zip
            District_Contact_Type_Id
          }
        }
      }`
      })
      .then(r => {
        return r.data.account;
      });
  },

  createAccount: async function(accountToAdd) {
    var query = `
      mutation($numUsers: Int!, $accountGroupId: Int!, $accountTypeId: Int!, $paymentMethodId: Int!, $billingName: String!, $billingAddressLine1: String!, $billingAddressLine2: String!, $billingCity: String!, $billingState: String!, $billingZip: String!, $billingPhone: String!) {
        CreateAccount(numUsers: $numUsers, accountGroupId: $accountGroupId, accountTypeId: $accountTypeId, paymentMethodId: $paymentMethodId, billingName: $billingName, billingAddressLine1: $billingAddressLine1, billingAddressLine2: $billingAddressLine2, billingCity: $billingCity, billingState: $billingState, billingZip: $billingZip, billingPhone: $billingPhone) {
          Account_Id
        }
      }`;
    var variables = {
      numUsers: parseInt(accountToAdd.Number_Of_Users),
      accountGroupId: parseInt(accountToAdd.AccountGroup_Id),
      accountTypeId: parseInt(accountToAdd.Account_Type_Id),
      paymentMethodId: parseInt(accountToAdd.Payment_Method_Id),
      billingName: accountToAdd.Billing_Name,
      billingAddressLine1: accountToAdd.Billing_Address_Line_1,
      billingAddressLine2: accountToAdd.Billing_Address_Line_2,
      billingCity: accountToAdd.Billing_City,
      billingState: accountToAdd.Billing_State,
      billingZip: accountToAdd.Billing_Zip,
      billingPhone: accountToAdd.Billing_Phone
    };

    return await this.$store.getters.fetcher({ query, variables }).then(r => {
      accountToAdd.Account_Id = r.data.CreateAccount.Account_Id;
      return accountToAdd;
    });
  },

  updateAccount: async function(accountToUpdate) {
    var query = `
      mutation($accountId: Int!, $numUsers: Int!, $accountGroupId: Int!, $accountTypeId: Int!, $paymentMethodId: Int!, $billingName: String!, $billingAddressLine1: String!, $billingAddressLine2: String!, $billingCity: String!, $billingState: String!, $billingZip: String!, $billingPhone: String!) {
        UpdateAccount(accountId: $accountId, numUsers: $numUsers, accountGroupId: $accountGroupId, accountTypeId: $accountTypeId, paymentMethodId: $paymentMethodId, billingName: $billingName, billingAddressLine1: $billingAddressLine1, billingAddressLine2: $billingAddressLine2, billingCity: $billingCity, billingState: $billingState, billingZip: $billingZip, billingPhone: $billingPhone) {
          Account_Id
        }
      }`;
    var variables = {
      accountId: parseInt(accountToUpdate.Account_Id),
      numUsers: parseInt(accountToUpdate.Number_Of_Users),
      accountGroupId: parseInt(accountToUpdate.Account_Group.AccountGroup_Id),
      accountTypeId: parseInt(accountToUpdate.Account_Type.Account_Type_Id),
      paymentMethodId: parseInt(
        accountToUpdate.Payment_Method.Payment_Method_Id
      ),
      billingName: accountToUpdate.Billing_Name,
      billingAddressLine1: accountToUpdate.Billing_Address_Line_1,
      billingAddressLine2: accountToUpdate.Billing_Address_Line_2,
      billingCity: accountToUpdate.Billing_City,
      billingState: accountToUpdate.Billing_State,
      billingZip: accountToUpdate.Billing_Zip,
      billingPhone: accountToUpdate.Billing_Phone
    };

    return await this.$store.getters.fetcher({ query, variables }).then(() => {
      return accountToUpdate;
    });
  },

  convertAccountTypeToOrganizationType(accountTypeId) {
    switch (accountTypeId) {
      case 1:
        return 1;
      case 2:
        return 2;
      case 3:
        return 4;
      case 4:
        return 6;
      case 5:
        return 2;
    }
  },

  getAccountTypes: async function() {
    return await this.$store.getters
      .fetcher({
        query: `{ accountTypes {
          Account_Type_Id
          Title
        }}`
      })
      .then(r => {
        return r.data.accountTypes;
      });
  },

  getPaymentMethods: async function() {
    return await this.$store.getters
      .fetcher({
        query: `{ paymentMethods {
          Payment_Method_Id
          Title
        }}`
      })
      .then(r => {
        return r.data.paymentMethods;
      });
  },

  createDistrictContact: async function(contactToCreate) {
    var query = `
      mutation($name: String!, $addressLine1: String, $addressLine2: String, $city: String, $state: String, $zip: String, $phone: String, $email: String, $accountId: Int!, $districtContactTypeId: Int!) {
        CreateDistrictContact(name: $name, addressLine1: $addressLine1, addressLine2: $addressLine2, city: $city, state: $state, zip: $zip, phone: $phone, email: $email, accountId: $accountId, districtContactTypeId: $districtContactTypeId) {
          District_Contact_Id
        }
      }`;
    var variables = {
      name: contactToCreate.Name,
      addressLine1: contactToCreate.Address_Line_1,
      addressLine2: contactToCreate.Address_Line_2,
      city: contactToCreate.City,
      state: contactToCreate.State,
      zip: contactToCreate.Zip,
      phone: contactToCreate.Phone,
      email: contactToCreate.Email,
      accountId: parseInt(contactToCreate.Account_Id),
      districtContactTypeId: parseInt(contactToCreate.District_Contact_Type_Id)
    };

    return await this.$store.getters.fetcher({ query, variables }).then(r => {
      contactToCreate.District_Contact_Id =
        r.data.CreateDistrictContact.District_Contact_Id;
      return contactToCreate;
    });
  },

  updateDistrictContact: async function(contactToUpdate) {
    var query = `
      mutation($districtContactId: Int!, $name: String!, $addressLine1: String, $addressLine2: String, $city: String, $state: String, $zip: String, $phone: String, $email: String, $accountId: Int!, $districtContactTypeId: Int!) {
        UpdateDistrictContact(districtContactId: $districtContactId, name: $name, addressLine1: $addressLine1, addressLine2: $addressLine2, city: $city, state: $state, zip: $zip, phone: $phone, email: $email, accountId: $accountId, districtContactTypeId: $districtContactTypeId) {
          District_Contact_Id
        }
      }`;
    var variables = {
      districtContactId: parseInt(contactToUpdate.District_Contact_Id),
      name: contactToUpdate.Name,
      addressLine1: contactToUpdate.Address_Line_1,
      addressLine2: contactToUpdate.Address_Line_2,
      city: contactToUpdate.City,
      state: contactToUpdate.State,
      zip: contactToUpdate.Zip,
      phone: contactToUpdate.Phone,
      email: contactToUpdate.Email,
      accountId: parseInt(contactToUpdate.Account_Id),
      districtContactTypeId: parseInt(contactToUpdate.District_Contact_Type_Id)
    };

    return await this.$store.getters.fetcher({ query, variables }).then(() => {
      return contactToUpdate;
    });
  }
};

export { account };
